<div class="supply-control-page">
  <div class="page-header">
    <div>
      <p class="eyebrow">Supply Flow</p>
      <h2>Supply Control Tower</h2>
      <p class="subtitle">Watch dispatch pace, buyer concentration, route pressure, and ticket value from one live board.</p>
    </div>
    <button mat-stroked-button (click)="loadTower()">Refresh</button>
  </div>

  <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>

  <section class="stats-grid">
    <article class="stat-card accent">
      <span>Average Ticket</span>
      <strong>₦{{ averageTicket | number:'1.0-0' }}</strong>
      <small>Average gross value per dispatch</small>
    </article>
    <article class="stat-card success">
      <span>Gross Value</span>
      <strong>₦{{ analytics?.grossAmount || 0 | number:'1.0-0' }}</strong>
      <small>Total gross dispatch value</small>
    </article>
    <article class="stat-card warning">
      <span>Commission Exposure</span>
      <strong>₦{{ analytics?.totalCommission || 0 | number:'1.0-0' }}</strong>
      <small>Current commission load</small>
    </article>
    <article class="stat-card primary">
      <span>Net Value</span>
      <strong>₦{{ analytics?.netAmount || 0 | number:'1.0-0' }}</strong>
      <small>Value retained after commission</small>
    </article>
  </section>

  <section class="content-grid">
    <article class="panel">
      <div class="panel-head">
        <h3>Recent Dispatch Flow</h3>
        <span>Latest 8 transactions</span>
      </div>
      <div class="dispatch-list" *ngIf="recentRows.length; else noRows">
        <div class="dispatch-row" *ngFor="let row of recentRows">
          <div>
            <strong>{{ row.buyerName || 'Unknown Buyer' }}</strong>
            <p>{{ row.productItemName || row.productTypeName || 'Supply Item' }}</p>
          </div>
          <div class="dispatch-meta">
            <span>{{ row.origin || 'Unknown' }} → {{ row.destination || 'Unknown' }}</span>
            <small>{{ row.dispatchDate | date:'mediumDate' }} · ₦{{ row.totalAmount | number:'1.0-0' }}</small>
          </div>
        </div>
      </div>
    </article>

    <article class="panel compact">
      <div class="panel-head">
        <h3>Top Buyers</h3>
        <span>By gross value</span>
      </div>
      <div class="metric-list" *ngIf="topBuyers.length; else noBuyers">
        <div class="metric-row" *ngFor="let row of topBuyers">
          <strong>{{ row.label }}</strong>
          <span>₦{{ row.value | number:'1.0-0' }}</span>
        </div>
      </div>
    </article>

    <article class="panel compact">
      <div class="panel-head">
        <h3>Route Pressure</h3>
        <span>Highest value lanes</span>
      </div>
      <div class="metric-list" *ngIf="routePressure.length; else noRoutes">
        <div class="metric-row" *ngFor="let row of routePressure">
          <strong>{{ row.label }}</strong>
          <span>₦{{ row.value | number:'1.0-0' }}</span>
        </div>
      </div>
    </article>
  </section>
</div>

<ng-template #noRows>
  <p class="muted">No dispatch transactions available yet.</p>
</ng-template>

<ng-template #noBuyers>
  <p class="muted">No buyer concentration data yet.</p>
</ng-template>

<ng-template #noRoutes>
  <p class="muted">No route pressure data yet.</p>
</ng-template>
